module.exports = __webpack_public_path__ + "static/media/NYE-small.6809b5f7.gif";